import { ContentParent } from "components/modules/Content/ContentParent";
import { ContentItem } from "components/modules/Content/ContentItem/ContentItem";
import {
    Award,
    Blend,
    FileStack,
    Gift,
    HeartHandshake,
    Lightbulb, MonitorSmartphone,
    MonitorSmartphoneIcon,
    PencilRuler
} from "lucide-react";
import { Translate } from "components/common/Translate/Translate";

const featureContentAsList = [
    {
        title: "smart-gif-optimizer-title",
        description: "smart-gif-optimizer-sub-title",
        icon: <Award strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "quick-and-easy-title",
        description: "quick-and-easy-sub-title",
        icon: <PencilRuler strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "free-gif-compression-title",
        description: "free-gif-compression-sub-title",
        icon: <HeartHandshake strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "compress-in-bulk-title",
        description: "compress-in-bulk-sub-title",
        icon: <FileStack strokeWidth={1.5} width={30} height={30} />,
    },

    {
        title: "transparency-handling-title",
        description: "transparency-handling-sub-title",
        icon: <Blend strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "cross-platform-compatibility-title",
        description: "cross-platform-compatibility-sub-title",
        icon: <MonitorSmartphone strokeWidth={1.5} width={30} height={30} />,
    },
];
export const GifCompressorFeaturesContent = () => {
    return (
        <ContentParent>
            {featureContentAsList.map((e, index) => {
                return (
                    <ContentItem
                        key={index}
                        title={<Translate keyName={e.title} />}
                        description={<Translate keyName={e.description} />}
                        icon={e.icon}
                    />
                );
            })}
        </ContentParent>
    );
};

//Smart GIF Optimizer
// You can reduce your GIF sizes by up to 60% without sacrificing quality. Our LZW compression is ideal for most GIFs and keeps them looking sharp.
//
// Quick and Easy to Use
// With our super straightforward interface, compressing your images is easy. Just a few clicks, and you're done.
//
// Free GIF Compression
// Shrink your GIFs, tweak their quality, or reduce their size—all without spending a cent.
//
// Compress in Bulk
// Got a lot of GIFs to handle? Compress them all at once and save yourself the headache.
//
// Transparency Handling
// "
// Our GIF compressor maintains transparency, so your GIFs stay sharp and clear even after compression."
//
// Cross-Platform Compatibility
// Our compressed GIFs are optimized to look great on any device, whether it's your phone, tablet, or desktop.

const content = {
    "smart-gif-optimizer-title": "Smart GIF Optimizer",
    "smart-gif-optimizer-sub-title":
        "You can reduce your GIF sizes by up to 60% without sacrificing quality. Our LZW compression is ideal for most GIFs and keeps them looking sharp.",
    "quick-and-easy-title": "Quick and Easy to Use",
    "quick-and-easy-sub-title":
        "With our super straightforward interface, compressing your images is easy. Just a few clicks, and you're done.",
    "free-gif-compression-title": "Free GIF Compression",

    "free-gif-compression-sub-title":
        "Shrink your GIFs, tweak their quality, or reduce their size—all without spending a cent.",
    "compress-in-bulk-title": "Compress in Bulk",
    "compress-in-bulk-sub-title":
        "Got a lot of GIFs to handle? Compress them all at once and save yourself the headache.",
    "transparency-handling-title": "Transparency Handling",
    "transparency-handling-sub-title":
        "Our GIF compressor maintains transparency, so your GIFs stay sharp and clear even after compression.",
    "cross-platform-compatibility-title": "Cross-Platform Compatibility",
    "cross-platform-compatibility-sub-title":
        "Our compressed GIFs are optimized to look great on any device, whether it's your phone, tablet, or desktop.",
};
